<div @skipFirstRender>
  <div class="spinner" *ngIf="isVisible" @fadeAnimation>
    <div class="lds-ring"><div></div><div></div><div></div><div></div></div>
  </div>
</div>

